/**
 * Touch Detection
 */
module.exports = function () {
  // js
  $(document).ready(function () {
    $('html').removeClass('no-js').addClass('js')
  })

  // touch
  var isTouchDevice = 'ontouchstart' in document.documentElement
  if (isTouchDevice) {
    $('body').removeClass('no-touch').addClass('touch')
  }
}
